import styled from "styled-components";
import TextArea from "../TextArea";

const StyledFormStringTextArea = styled.div`
    display: block;
    padding-top: 15px;
    align-items: center;

    textarea {
        margin-top: 5px;
        padding: 9px 13px;
        height: 35px;
        font-size: 12px;
        font-weight: 400;
    }
`;

const LabelRegular = styled.div`
    font-size: 12px;
    font-weight: 600;
`;

function FormStringTextArea(props) {

    const {label, value, placeholder, onChange, inputStyle, disabled, validated, onPressEnter, ...restProps} = props;

    return (
        <StyledFormStringTextArea {...restProps}>
            {label && <LabelRegular>{label}</LabelRegular>}
            <TextArea placeholder={placeholder} value={value} onChange={(e) => {if (onChange) onChange(e.target.value)}} onPressEnter={onPressEnter} disabled={disabled} validated={validated} style={inputStyle}></TextArea>
        </StyledFormStringTextArea>
    )
}

export default FormStringTextArea;